import { getContrast } from "polished";

export const hasEnoughContrast = (color1: string, color2: string, threshold = 2.5): boolean => {
  if (!color1 || !color2) return false;

  return getContrast(color1, color2) > threshold;
};
